import { stripToFactDims } from './stripToFactDims'

/** Prune carried page dims to those the active fact supports. Returns the pruned
 *  filters / group-by / columns plus the distinct dropped dim names (for the notice).
 *  `columns` survives only when it is a fact dim AND still present in the pruned group-by
 *  (the useColumnsState invariant: columns ⊆ groupBy). */
export function pruneDimsToFact(
  filters: Record<string, string[]>,
  groupBy: string[],
  columns: string | null,
  factDims: Set<string>,
): {
  filters: Record<string, string[]>
  groupBy: string[]
  columns: string | null
  dropped: string[]
} {
  const { filters: f, groupBy: g } = stripToFactDims(filters, groupBy, factDims)
  const cols = columns && factDims.has(columns) && g.includes(columns) ? columns : null
  const dropped = new Set<string>()
  for (const k of Object.keys(filters)) if (!factDims.has(k)) dropped.add(k)
  for (const d of groupBy) if (!factDims.has(d)) dropped.add(d)
  if (columns && !factDims.has(columns)) dropped.add(columns)
  return { filters: f, groupBy: g, columns: cols, dropped: [...dropped] }
}
